import React from 'react';
import { Alert, Layout } from 'antd';
import Header from '../shared/Header';
import DeepAnalysisDashboardOverview from '../DeepAnalysisDashboardOverview';
import DomainSetupCheck from '../websiteIndexEntry/DomainSetupCheck';
import useGetCurrentWebsite from '../websiteIndexEntry/hooks/useGetCurrentWebsite';
import LoaderCard from '../shared/LoaderCard';
import WebsiteIndexEntrySelector from '../websiteIndexEntry/WebsiteIndexEntrySelector';
import HeaderActions from '../shared/HeaderActions';
import UrlClusters from '../urlClusters/UrlClusters';
import UrlFailedChecks from '../failedChecks/UrlFailedChecks';
import WebsiteConfigurationFailedChecks from '../failedChecks/WebsiteConfigurationFailedChecks';

const { Content } = Layout;

export default function DeepAnalysisDashboardPage() {
    const { website, isLoading } = useGetCurrentWebsite();
    const websiteGuid = website?.guid;
    const invalidDomain = !websiteGuid && !isLoading;

    return (
        <Content className="general-layout-content">
            {isLoading && <LoaderCard />}

            {invalidDomain && (
                <Alert
                    showIcon
                    type="error"
                    message="Invalid domain"
                />
            )}

            {!isLoading && websiteGuid && (
                <>
                    <Header
                        title={<WebsiteIndexEntrySelector />}
                        rightSideExtra={<HeaderActions websiteGuid={websiteGuid} />}
                    />
                    <DomainSetupCheck
                        key={websiteGuid}
                        websiteGuid={websiteGuid}
                    >
                        <DeepAnalysisDashboardOverview websiteGuid={websiteGuid} />
                        <WebsiteConfigurationFailedChecks websiteGuid={websiteGuid} />
                        <UrlClusters websiteGuid={websiteGuid} />

                        <UrlFailedChecks websiteGuid={websiteGuid} />
                    </DomainSetupCheck>
                </>
            )}
        </Content>
    );
}
